import { render, staticRenderFns } from "./PremiumOnboarding.vue?vue&type=template&id=0e6f639f&scoped=true"
import script from "./PremiumOnboarding.vue?vue&type=script&lang=ts"
export * from "./PremiumOnboarding.vue?vue&type=script&lang=ts"
import style0 from "./PremiumOnboarding.vue?vue&type=style&index=0&id=0e6f639f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6f639f",
  null
  
)

export default component.exports